const NORMALIZED_DATA_DESCRIPTION =
  'These scores have been normalized across multiple proprietary ESG data scoring sources, then aggregated at the subcategory level and further aggregated at the main category level.';

export default NORMALIZED_DATA_DESCRIPTION;
